import { useDispatch, useSelector } from 'react-redux'
import classes from './AppointmentsHeaderCell.module.css'
import { useState } from 'react'
import { appointmentsActions } from '../../store/appointments'

export default function AppointmentsHeaderCell({item}) {
    const dispatch = useDispatch()
    const [sortDirection, setSortDirection] = useState(true)

    const orderFilters = useSelector(state => state.appointments.orderFilters)
    const loading = useSelector(state => state.appointments.loading)

    async function sortTableHandler() {
        setSortDirection(prev => prev = !prev)
        dispatch(appointmentsActions.setOrderFilters({
            id: item.id,
            label: item.label,
            isDesc: sortDirection
        }))
    }

    return <div className={classes.header_cell} > 
        <div>
            {item.name} 
        </div>
        {item.sortable ? <button onClick={sortTableHandler} disabled={loading} className={`${classes.button} ${(orderFilters && orderFilters.id == item.group+item.label )? classes.active : ''}`}>
            {loading && <span className={`loader`}></span>}
            {!loading && <>
                {(orderFilters && orderFilters.id == item.group+item.label) ?  <>
                        {orderFilters.isDesc && <i className='ti ti-sort-descending'></i>}
                        {!orderFilters.isDesc && <i className='ti ti-sort-ascending'></i>}
                    </>
                    : <i className='ti ti-sort-descending'></i>}
            </>}
        </button> : ''}
    </div>
}